import { html, utl_renderObjects, utl_fadeIn, utl_handleModalClose } from "../base/_utils";
import { staff } from "../data/_staff";
import staffCard from "../components/templates/_staff-card";
import edgeLineInit from "../components/_edge-line";

edgeLineInit();

document.addEventListener("DOMContentLoaded", () => {
    const staffWrapper = document.querySelector("#staff-wrapper");

    utl_renderObjects({
        data: staff,
        template: (member) => html`<div class="col-md-6 col-lg-4 col-xxl-3 mb-6 fade-in">${staffCard(member, "../../", "tertiary")}</div>`,
        target: (member) => {
            if (member.dept === "admin") {
                return "#admin-container";
            } else if (member.dept === "annualFund") {
                return "#annual-fund-container";
            } else if (member.dept === "donorExp") {
                return "#donor-exp-container";
            } else if (member.dept === "internalOps") {
                return "#internal-ops-container";
            } else if (member.dept === "leadershipGifts") {
                return "#leadership-gifts-container";
            } else if (member.dept === "premiumSales") {
                // MarkUp #16
                return "#premium-sales-container";
            } else {
                return "#ticketing-container";
            }
        },
    });

    staffWrapper.classList.remove("min-vh-100");
    utl_fadeIn();
    utl_handleModalClose();
});
